<smart-input [(model)]="variable" key="name"></smart-input>
<smart-input [(model)]="variable" key="type"></smart-input>
<smart-input [(model)]="variable" key="value" *ngIf="variable?.type" [forceDisplay]="getDisplayType(variable.type)"
             [format]="variable.type === 'dayMonth' ? 'dd-mm' : undefined"></smart-input>

<button (click)="save()" mat-button>Save</button>
